/* eslint-disable */
export default {
  confirmationInfo:
    '前の通話で保存されていない編集内容は失われます。新しい通話で作業しますか？',
  log: 'ログ',
  save: '保存して新しい通話で作業',
  discard: '破棄して新しい通話で作業',
  stay: '前の作業を続ける',
} as const;

// @key: @#@"confirmationInfo"@#@ @source: @#@"Your unsaved edits on the previous call will be lost, are you sure you want to work on the new call?"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save & Work on New"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard & Work on New"@#@
// @key: @#@"stay"@#@ @source: @#@"Stay on Previous Work"@#@
